const addComment = comment => ({
  type: 'ADD_COMMENT',
  comment,
});

export default addComment;
